import React from "react";
import "../App.css";
import "./Profile.css"
import avatar from "./images/avatar.png"
import HeaderNav from "../misc/headerNav"
import Popup from "./deleteProfile";
import { Navigate } from "react-router-dom";
// The Profile component shows data from the user table.  This is set up fairly generically to allow for you to customize
// user data by adding it to the attributes for each user, which is just a set of name value pairs that you can add things to
// in order to support your group specific functionality.  In this example, we store basic profile information for the user

export default class Profile extends React.Component {

  // The constructor will hold the default values for the state.  This is also where any props that are passed
  // in when the component is instantiated will be read and managed.  
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      email: "",
      username_current: "",
      email_current: "",
      responseMessage: "",
      popup: false,
      userId: props.userId,
      totalLikes: "0",
      avatarUrl: "https://webdev.cse.buffalo.edu/hci/api/uploads/files/ZkhMxfMTnbdJywLC26lZDX5nox35VJatc3rcwIq9nOw.gif",
      deleteComplete: false,
      usernameError: false,
      emailError: false,
      passwordError: false,
      generalError: false,
      generalState: "",
      // NOTE : if you wanted to add another user attribute to the profile, you would add a corresponding state element here
    };
    this.fieldChangeHandler.bind(this);
    this.uploadHandler.bind(this);
    this.resetPasswordHandler.bind(this);
  }

  // This is the function that will get called every time we change one of the fields tied to the user data source.
  // it keeps the state current so that when we submit the form, we can pull the value to update from the state.  Note that
  // we manage multiple fields with one function and no conditional logic, because we are passing in the name of the state
  // object as an argument to this method.  
  fieldChangeHandler(field, e) {
    console.log("field change");
    this.setState({
      [field]: e.target.value
    });
  }


  // This is the function that will get called the first time that the component gets rendered.  This is where we load the current
  // values from the database via the API, and put them in the state so that they can be rendered to the screen.  
  componentDidMount() {
    console.log("In profile");
    console.log(this.props);

    // fetch the user data, and extract out the attributes to load and display
    fetch(process.env.REACT_APP_API_PATH + "/users/" + sessionStorage.getItem("user"), {
      method: "get",
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + sessionStorage.getItem("token")
      }
    })
      .then(res => {

        if (!res.ok) {
          this.setState({
            generalError: true,
            generalState: "Ooops something went wrong! Please reload page.",
          });
          return;
        }

        return res.json();
      })
      .then(
        result => {
          if (result) {
            console.log(result);
            if (result.attributes) {
              this.setState({
                // IMPORTANT!  You need to guard against any of these values being null.  If they are, it will
                // try and make the form component uncontrolled, which plays havoc with react
                username: result.attributes.username || "",
                email: result.email || "",
                username_current: result.attributes.username || "",
                email_current: result.email || "",
                avatarUrl: result.attributes.pfp || "",
                totalLikes: result.attributes.totalLikes || ""
              });
            }
          }
        }
      );


  }

  // This is the function that will get called when the submit button is clicked, and it stores
  // the current values to the database via the api calls to the user and user_preferences endpoints
  submitHandler = (event, attr) => {

    //keep the form from actually submitting, since we are handling the action ourselves via
    //the fetch calls to the API
    event.preventDefault();

    // If our new email is empty
    if (this.state.email === "") {
      this.setState({
        emailError: true,
      });
      return;
    } else {
      this.setState({
        emailError: false,
      });
      this.forceUpdate();
    }

    // If the changed username is not good error
    if (this.state.username === "") {
      this.setState({
        usernameError: true,
      });
      return;
    } else {
      this.setState({
        usernameError: false,
      });
      this.forceUpdate();
    }

    let sent_email = attr === 'email' ? this.state.email : this.state.email_current;
    let sent_username = attr === 'username' ? this.state.username : this.state.username_current;

    //make the api call to the user controller, and update the user fields (username, firstname, lastname)
    fetch(process.env.REACT_APP_API_PATH + "/users/" + sessionStorage.getItem("user"), {
      method: "PATCH",
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + sessionStorage.getItem("token")
      },
      body: JSON.stringify({
        email: sent_email,
        attributes: {
          username: sent_username,
          pfp: this.state.avatarUrl,
          totalLikes: this.state.totalLikes
        }
      })
    })
      .then(res => {

        if (!res.ok) {
          this.setState({
            generalError: true,
            generalState: "Ooops something went wrong! Please reload page.",
          });
          return;
        }

        return res.json();
      })
      .then(
        result => {
          this.setState({
            responseMessage: result.Status,
            username_current: sent_username,
            email_current: sent_email
          });
        }
      );
  };


  uploadHandler = event => {

    event.preventDefault();

    const formData = new FormData()
    const fileField = document.querySelector('input[type="file"]');

    formData.append('uploaderID', Number(sessionStorage.getItem("user")));
    formData.append('attributes', JSON.stringify({}));
    formData.append('file', fileField.files[0]);
    fetch(process.env.REACT_APP_API_PATH + "/file-uploads", {
      method: "post",
      headers: {
        'Authorization': 'Bearer ' + sessionStorage.getItem("token")
      },
      body: formData
    })
      .then(res => {

        if (!res.ok) {
          this.setState({
            generalError: true,
            generalState: "Oh no! The image uploaded had issues with it (this image may be to large or small).",
          });
          return;
        }

        return res.json();
      })
      .then(
        result => {
          this.setState({
            avatarUrl: `https://webdev.cse.buffalo.edu${result.path}`
          })
          fetch(process.env.REACT_APP_API_PATH + "/users/" + sessionStorage.getItem("user"), {
            method: "PATCH",
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + sessionStorage.getItem("token")
            },
            body: JSON.stringify({
              email: this.state.email_current,
              attributes: {
                username: this.state.username_current,
                pfp: this.state.avatarUrl,
                totalLikes: this.state.totalLikes
              }
            })
          })
            .then(res => {

              if (!res.ok) {
                this.setState({
                  generalError: true,
                  generalState: "Connection with server is not good. Something went wrong that is not your fault.",
                });
                return;
              }

              return res.json();
            })
            .then(
              result => {
                this.setState({
                  responseMessage: result.Status
                });
              }
            );
        }
      )
    //document.getElementById("pfp").src={avatarUrl}
  }

  resetPasswordHandler = event => {
    event.preventDefault();

    // // If the changed password is no good
    // if (event.target.value === "") {
    //   this.setState({
    //     passwordError: true,
    //   });
    //   return;
    // } else {
    //   this.setState({
    //     passwordError: false,
    //   });
    // }

    fetch(process.env.REACT_APP_API_PATH + "/auth/request-reset", {
      method: "post",
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + sessionStorage.getItem("token")
      },
      body: JSON.stringify({
        email: this.state.email_current
      })
    }).then(
      result => {

        if (!result.ok) {
          this.setState({
            generalError: true,
            generalState: "Ooops something went wrong! Please reload page.",
          });
          return;
        }
      }
    )
  }


  openPopup = (event) => {
    if (this.state.popup === false) {
      this.setState({ popup: true })
    } else {
      this.setState({ popup: false })
    }
  }

  deleteAccountHandler = (event) => {


    console.log("We are in the delete function")
    console.log(sessionStorage.getItem("user"))

    // We need to logout before we are able to resignin/ this should be sprint 3 items.

    console.log("we are here")

    fetch(process.env.REACT_APP_API_PATH + "/auth/logout", {
      method: "post",
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + sessionStorage.getItem("token")
      }
    })
      .then(
        result => {

          if (!result.ok) {
            this.setState({
              generalError: true,
              generalState: "Ooops something went wrong! Please reload page.",
            });
            return;
          }
          sessionStorage.removeItem("token")
          this.props.logout()
        }
      )

    fetch(process.env.REACT_APP_API_PATH + "/users/" + sessionStorage.getItem("user") + "/?" + "relatedObjectsAction=delete", {
      method: "DELETE",
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + sessionStorage.getItem("token")
      },
    }).then(res => {
      if (!res.ok) {
        this.setState({
          generalError: true,
          generalState: "Ooops something went wrong! Please reload page.",
        });
        return;
      }
      this.setState({
        deleteComplete: true
      })
    });
  }


  // This is the function that draws the component to the screen.  It will get called every time the
  // state changes, automatically.  This is why you see the username and firstname change on the screen
  // as you type them.
  render() {


    return (
      <div>
        <HeaderNav />
        <div className="box">

          <div className="insideBox">

            <p className="accSettings">Account Settings</p>

            <div className="settingsRow">
              <Popup trigger={this.state.popup} handlerFunction={this.openPopup} deletehandler={this.deleteAccountHandler}></Popup>
              {this.state.deleteComplete ? <Navigate to="/" /> : ""}
              <img className="pfpBig" src={this.state.avatarUrl !== '' ? this.state.avatarUrl : avatar} alt={this.state.username_current}></img>
              <button className="deleteButton" onClick={this.openPopup}>Delete Account</button>
            </div>

            <form>
              <label className="changePfp">
                <input className="textBoxs" type="file" accept="image/*" onChange={e => this.uploadHandler(e)} />
                Change Profile Picture
                <p />
                {this.state.generalError ? <div className="profileerrorfield">{this.state.generalState}</div> : ""}
              </label>
              <div className="text">
                Username
                <br></br>
                <input class="text" type="text" onChange={e => this.fieldChangeHandler("username", e)} value={this.state.username} />
                <button className="change" onClick={e => this.submitHandler(e, 'username')}>Change</button>
                {this.state.usernameError ? <div className="mainerrorfield">Enter a valid username</div> : ""}
                <br></br>
                Email
                <br></br>
                <input type="text" onChange={e => this.fieldChangeHandler("email", e)} value={this.state.email} />
                <button className="change" onClick={e => this.submitHandler(e, 'email')}>Change</button>
                {this.state.emailError ? <div className="mainerrorfield">Enter a valid email!</div> : ""}
                <br></br>
                Password
                <br></br>
                <input type="password" value='ʕ•́ᴥ•̀ʔっ fake password'></input>
                <button className="change" onClick={e => this.resetPasswordHandler(e)}>Change</button>
                {this.state.passwordError ? <div className="mainerrorfield">Enter a valid password!</div> : ""}
                <br></br>
              </div>

              {this.state.responseMessage}
            </form>

          </div>
        </div>

      </div>
    );
  }
}